var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.7 14.7 3H9.3l-.9 2.7M3 5.7h18M19.65 5.7 17.85 21H6.15L4.35 5.7M12 7.95v10.8M12 7.95v10.8M15.6 7.95l-.9 10.8M8.4 7.95l.9 10.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTrash;